/**
 * @generated SignedSource<<2e45b0490dd6ed9221424685d652f3b0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateReportInput = {
  clientMutationId?: string | null | undefined;
  report: ReportInput;
};
export type ReportInput = {
  message?: string | null | undefined;
  toUserId: any;
};
export type useReportMutation$variables = {
  input: CreateReportInput;
};
export type useReportMutation$data = {
  readonly createReport: {
    readonly clientMutationId: string | null | undefined;
    readonly query: {
      readonly currentUser: {
        readonly " $fragmentSpreads": FragmentRefs<"LikesList_user" | "MessagesView_user">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useReportMutation = {
  response: useReportMutation$data;
  variables: useReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v4 = [
  (v3/*:: as any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Photo",
  "kind": "LinkedField",
  "name": "headshot",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorageObject",
      "kind": "LinkedField",
      "name": "storageObject",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blurhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v8/*:: as any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fromUser": {
        "status": {
          "equalTo": "ACTIVE"
        }
      }
    }
  },
  (v3/*:: as any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "IS_SPARK_DESC",
      "SPARKED_AT_DESC",
      "ROW_ID_DESC"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateReportPayload",
        "kind": "LinkedField",
        "name": "createReport",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MessagesView_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LikesList_user"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateReportPayload",
        "kind": "LinkedField",
        "name": "createReport",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v4/*:: as any*/),
                    "concreteType": "ConversationConnection",
                    "kind": "LinkedField",
                    "name": "conversations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v5/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Conversation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Match",
                                "kind": "LinkedField",
                                "name": "match",
                                "plural": false,
                                "selections": [
                                  (v6/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Profile",
                                    "kind": "LinkedField",
                                    "name": "profile",
                                    "plural": false,
                                    "selections": [
                                      (v7/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "closestCity",
                                        "storageKey": null
                                      },
                                      (v9/*:: as any*/),
                                      (v8/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unreadCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Message",
                                "kind": "LinkedField",
                                "name": "lastMessage",
                                "plural": false,
                                "selections": [
                                  (v10/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  },
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v12/*:: as any*/)
                    ],
                    "storageKey": "conversations(first:20)"
                  },
                  {
                    "alias": null,
                    "args": (v4/*:: as any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "MessagesView_user_conversations",
                    "kind": "LinkedHandle",
                    "name": "conversations"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unviewedMatchMessagesCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unviewedSystemMessagesCount",
                    "storageKey": null
                  },
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v13/*:: as any*/),
                    "concreteType": "LikeConnection",
                    "kind": "LinkedField",
                    "name": "likes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LikeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v5/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Like",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSpark",
                                "storageKey": null
                              },
                              (v6/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sparkedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Profile",
                                "kind": "LinkedField",
                                "name": "profile",
                                "plural": false,
                                "selections": [
                                  (v7/*:: as any*/),
                                  (v9/*:: as any*/),
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewedAt",
                                "storageKey": null
                              },
                              (v8/*:: as any*/),
                              (v11/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v12/*:: as any*/),
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": "likes(filter:{\"fromUser\":{\"status\":{\"equalTo\":\"ACTIVE\"}}},first:20,orderBy:[\"IS_SPARK_DESC\",\"SPARKED_AT_DESC\",\"ROW_ID_DESC\"])"
                  },
                  {
                    "alias": null,
                    "args": (v13/*:: as any*/),
                    "filters": [
                      "filter",
                      "orderBy"
                    ],
                    "handle": "connection",
                    "key": "LikesList_user_likes",
                    "kind": "LinkedHandle",
                    "name": "likes"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unviewedLikesCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "09949899ebc05192e8ce99d9c7a6bf34",
    "id": null,
    "metadata": {},
    "name": "useReportMutation",
    "operationKind": "mutation",
    "text": "mutation useReportMutation(\n  $input: CreateReportInput!\n) {\n  createReport(input: $input) {\n    clientMutationId\n    query {\n      currentUser {\n        ...MessagesView_user\n        ...LikesList_user\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment LikesListItem_like on Like {\n  createdAt\n  isSpark\n  rowId\n  sparkedAt\n  profile {\n    name\n    ...ProfileListItem_profile\n    id\n  }\n  viewedAt\n}\n\nfragment LikesList_user on User {\n  likes(first: 20, filter: {fromUser: {status: {equalTo: ACTIVE}}}, orderBy: [IS_SPARK_DESC, SPARKED_AT_DESC, ROW_ID_DESC]) {\n    edges {\n      cursor\n      node {\n        ...LikesListItem_like\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  unviewedLikesCount\n  id\n}\n\nfragment MessagesViewMatchItem_conversation on Conversation {\n  match {\n    rowId\n    profile {\n      name\n      closestCity\n      ...ProfileListItem_profile\n      id\n    }\n    id\n  }\n  unreadCount\n}\n\nfragment MessagesViewSystemItem_conversation on Conversation {\n  lastMessage {\n    createdAt\n    title\n    id\n  }\n  unreadCount\n}\n\nfragment MessagesView_user on User {\n  conversations(first: 20) {\n    edges {\n      cursor\n      node {\n        type\n        ...MessagesViewMatchItem_conversation\n        ...MessagesViewSystemItem_conversation\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  unviewedMatchMessagesCount\n  unviewedSystemMessagesCount\n  id\n}\n\nfragment ProfileAvatar_profile on Profile {\n  headshot {\n    storageObject {\n      blurhash\n      bucket\n      key\n    }\n    id\n  }\n  name\n}\n\nfragment ProfileListItem_profile on Profile {\n  name\n  ...ProfileAvatar_profile\n}\n"
  }
};
})();

(node as any).hash = "09c460f3595e666b12f09fd4b2180b36";

export default node;
